<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <PaymentDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      :currencyId="recItems.currencyId"
      paymentType="sale"
      isCardColor="true"
      :exchangeGainLoss="exchangeGainLoss"
      @register="register"
      @cancel="cancel"
    >
      <template v-slot:[pageData[2].name]>
        <ClientInfo :recItems="recItems" />
      </template>
      <template v-slot:[pageData[3].name]>
        <OperationDetail :recItems="recItems" type="sale" />
      </template>
    </PaymentDialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PaymentDialogBase from './PaymentDialogBase'

import headersHistory from '@/views/sales/History/headers'
import ClientInfo from '@/components/layouts/ClientConfirmation/CustomerInfo/CustomerInfoBase'
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'
import { saleUtil, commonUtil } from '@/util'
import { BigNumber } from 'bignumber.js'

export default {
  components: {
    PaymentDialogBase,
    ClientInfo,
    OperationDetail
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: [],

    recDetail: {
      productListHeaders: headersHistory.productListHeaders
    },
    exchangeGainLoss: ''
  }),
  async created() {
    // await this.ini()
  },

  methods: {
    ...mapActions('Sale', [
      'getSalePaymentListFromApi',
      'registerSalePayment',
      'cancelSalePayment'
    ]),
    ...mapActions('Common', ['setIsLoading']),
    getAmount() {
      // 合計金額
      return saleUtil.calcSaleAmountById(this.recItems.saleId)
    },
    getPayAmount(paymentList) {
      // 入金済金額
      return paymentList.data.reduce((sum, ele) => {
        return sum + Number(ele.amount)
      }, 0)
    },
    async ini() {
      const paymentList = await this.getSalePaymentListFromApi({
        id: this.recItems.saleId
      })

      const amount = commonUtil.formatPrice(this.getAmount())
      const payAmount = commonUtil.formatPrice(this.getPayAmount(paymentList))
      const notPayAmount = BigNumber(amount).minus(payAmount).toNumber()

      this.pageData = [
        {
          title: 'payment.payment_sale-payment',
          name: 'paymentInfo',
          items: [
            {
              name: 'payment.payment_total-price-no-colon',
              data: amount
            },
            {
              name: 'payment.payment_unpaid-price',
              data: notPayAmount
            },
            { name: 'payment.payment_sale-payment-date' },
            { name: 'payment.payment_sale-payment-price' },
            {
              name: 'payment.payment_sale-payment-method',
              component: 'SelectPaymentMethod'
            },
            { name: 'payment.payment_sale-payment-method-register' },
            { name: 'payment.payment_sale-payment' }
          ],
          data: {
            id: this.recItems.saleId,
            date: '',
            method: {},
            notPayAmount: notPayAmount
          },
          itemKey: ''
        },
        {
          title: 'payment.payment_sale-payment-history',
          name: 'paymentHistory',
          buttonName: 'payment.payment_sale-payment-cancel',
          itemKey: 'salePaymentId',
          headers: [
            {
              text: 'payment.payment_sale-payment-date',
              value: 'date',
              sortable: false,
              width: '12%'
            },
            {
              text: 'payment.payment_sale-payment-price',
              value: 'amount',
              sortable: false,
              width: '12%',
              align: 'end'
            },
            {
              text: 'payment.payment_sale-payment-method',
              value: 'paymentMethodId',
              sortable: false,
              width: '12%'
            },
            {
              text: 'payment.payment_operation',
              value: 'operationId',
              sortable: false
            }
          ],
          items: paymentList.data,
          footers: [
            {
              name: 'payment.payment_already-sale-payment-price',
              data: payAmount
            },
            {
              name: 'payment.payment_total-price-no-colon',
              data: amount
            },
            {
              name: 'payment.payment_unpaid-price',
              data: notPayAmount
            }
          ]
        },
        {
          title: 'payment.payment_customer-info',
          name: 'customerInfo'
        },
        {
          title: 'common.input_sale-details',
          name: 'salesDetail'
        }
      ]
    },
    async register() {
      this.setIsLoading(true)
      const isConfirmed = confirm(
        this.$t('payment.payment_sale-payment-save-question')
      )
      if (isConfirmed) {
        const isSucceed = await this.registerSalePayment(this.pageData[0].data)
        if (isSucceed) {
          alert(this.$t('common.common_saved-alert'))
          this.$emit('complete')
          // this.inputedValue.dialog = false
        }
      }
      this.setIsLoading(false)
    },
    async cancel(id) {
      const isConfirmed = confirm(
        this.$t('order.order_confirm-to-sale-payment')
      )
      if (isConfirmed) {
        const isSucceed = await this.cancelSalePayment(id)
        if (isSucceed) {
          alert(this.$t('common.common_canceled-alert'))
          this.$emit('complete')
          // this.inputedValue.dialog = false
        }
      }
    },
    async getExchangeGainLoss() {
      if (
        !this.pageData ||
        !this.pageData[0].data.notPayAmount ||
        !this.pageData[0].data.date
      )
        return

      const registerDateFxRate = await commonUtil.getFxRate(
        this.recItems.saleDate
      )
      const inputDateFxRate = await commonUtil.getFxRate(
        this.pageData[0].data.date
      )

      const registerDateExchangedPrice = commonUtil.exchangePriceByFxRate(
        this.recItems.currencyId,
        this.getUserInfoFromState.organization.currencyId,
        this.pageData[0].data.notPayAmount,
        registerDateFxRate
      )
      const inputDateExchangedPrice = commonUtil.exchangePriceByFxRate(
        this.recItems.currencyId,
        this.getUserInfoFromState.organization.currencyId,
        this.pageData[0].data.notPayAmount,
        inputDateFxRate
      )
      this.exchangeGainLoss = commonUtil.formatPrice(
        inputDateExchangedPrice - registerDateExchangedPrice
      )
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    ...mapGetters('User', ['getUserInfoFromState'])
  },
  watch: {
    inputedValue: {
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.dialog) await this.ini()
      }
    },
    pageData: {
      deep: true,
      handler() {
        this.getExchangeGainLoss()
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
